import { redirect } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'
import { STORY_OVERVIEW_TILE_SET } from 'services/sets/story'
import StoriesPageViewStore from 'store/pages/stories'
import { StoryOverviewFilter, validFilterNames } from './StoryOverviewPage'

export default {
  fetch: async ({ store, service, query, pathname }: FetchProps) => {
    if (
      query.contentTypes &&
      !validFilterNames.includes(query.contentTypes as StoryOverviewFilter)
    ) {
      throw redirect(
        pathname,
        {},
        {
          replaceState: true,
        },
      )
    }

    const { storiesPage } = store

    const { storyIds, pagination } = await service.stories.requestStories(
      store.user.gender,
      STORY_OVERVIEW_TILE_SET,
      {
        filter: query.contentTypes,
        pageNumber: 1,
        perPage: StoriesPageViewStore.storiesPerBatch,
      },
    )

    let reachedEnd = false
    if (pagination.currentPage && pagination.totalPages) {
      reachedEnd = pagination.currentPage >= pagination.totalPages
    }

    storiesPage.reset({
      storiesAreLoaded: true,
      storyIds,
      currentBatchNumber: pagination.currentPage,
      totalAvailableStories: pagination.total,
      totalBatches: pagination.totalPages,
      reachedEndOfStream: reachedEnd,
    })

    if (storiesPage.storyIds.length) {
      storiesPage.rowBuilder.resetTiles(
        storiesPage.storyIds?.length
          ? storiesPage.storyIds.map(storyId => ({
              type: 'story',
              id: storyId,
            }))
          : [],
      )
    }
  },

  defer: ({ store, query }: FetchProps) => {
    if (query && query.notification === '1') {
      const { t, toastNotifications } = store
      toastNotifications.addNotification({
        id: 'redirect_invalid_story',
        duration: 12000,
        type: 'warning',
        message: t('Hinweis'),
        additionalMessage: t(
          'Es tut uns leid, aber diese Story ist leider nicht mehr online. Hier kannst du dich von unseren neuen Stories inspirieren lassen.',
        ),
      })
    }
  },
}
